export default __webpack_public_path__ + "static/cat3-97d5fd9843a61860fed7fd85f1e47d59.jpg";